import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Tilt from "react-parallax-tilt";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              MI <span className="purple"> PRESENTO </span> 
            </h1>
            <p className="home-about-body">
              Mi chiamo Armando, ho 22 anni e vengo dalla Campania. Attualmente frequento l'ultimo anno del corso di laurea triennale in <b className="purple">Informatica</b> presso l'Università <b className="purple">Federico II</b> di Napoli.

              <br />
              <br />
              Nel corso dei miei studi ho acquisito competenze in:
              <i>
                <b className="purple">
                  {" "}
                    C, C++, Java, Python, HTML, CSS, JavaScript, PostgreSQL{" "}
                </b>
              </i>
                 e mi affascina la cybersecurity, sono una persona curiosa: mi piace molto imparare cose nuove.
              <br />
              <br />
              Oltre all'informatica, coltivo diverse passioni tra cui: <b className="purple">videogiochi, anime, film, serie TV</b> e <b className="purple">palestra</b>.
              La mia avventura su 
                <b className="purple">{" "}Minecraft</b> è iniziata dal <b className="purple">16 marzo 2014</b>,
              ho iniziato a giocare inizialmente col launcher SP con nickname come: <b className="purple"> ARMANDO, MasterWarbot, MasterPlays__, e Master_Plays </b>, per poi diventare Premium dal 2020 con
              il mio nickname attuale:{" "}
              <i>
                <b className="purple">ImMaster__</b>.
              </i>
              <br />
              <br />
              Sono un grande appassionato delle modalità:
              <i>
                <b className="purple">Roleplay, Minigames, Prison, SkyBlock, MMORPG, Parkour, PvP, PvE</b>.
              </i>
              <br />
              <br />
              In particolare, per i{" "} 
              <i>
                <b className="purple">Roleplay</b>,{" "}
              </i>
              gioco dal 2020 su{" "}
              <i>
                <b className="purple">Tecnocraft{" "}</b>
              </i>
              e dal 2023 su{" "}
              <i>
                <b className="purple">Atlantis</b>.
              </i>
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={"https://i.imgur.com/MD2UIdk.png"} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
